import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import FunnelBars from "./FunnelBars";
import { Flame, ChevronRight } from "lucide-react";

/** Dashboard summary: the whole funnel from email sent to call booked. */
export default function FunnelSummaryCard() {
  const [data, setData] = useState(null);
  const [days, setDays] = useState(90);

  useEffect(() => {
    api.get(`/funnel/summary?days=${days}`).then(r => setData(r.data)).catch(() => setData(null));
  }, [days]);

  const stages = data?.stages || [];
  const empty = !stages.length || stages[0].count === 0;

  return (
    <div className="card mb-6" style={{padding:18}} data-testid="dashboard-funnel">
      <div className="flex justify-between items-center mb-4" style={{flexWrap:"wrap",gap:10}}>
        <div>
          <div className="h-section">Funnel: dall'email alla call</div>
          <div className="text-small text-muted mt-1">
            {data ? `${data.analysed_leads} lead analizzati · tempo medio sul report ${data.avg_dwell_seconds}s` : "—"}
          </div>
        </div>
        <div className="flex gap-2 items-center">
          {[7, 30, 90].map(d => (
            <button key={d} onClick={() => setDays(d)} data-testid={`funnel-window-${d}`}
              className={`btn btn-sm ${days === d ? "btn-primary" : "btn-secondary"}`}>{d}gg</button>
          ))}
          <Link to="/funnel" className="btn btn-sm btn-secondary" data-testid="funnel-detail-link">
            Dettaglio lead <ChevronRight size={14}/>
          </Link>
        </div>
      </div>

      {empty ? (
        <div className="text-muted text-small" data-testid="dashboard-funnel-empty">
          Nessuna email inviata negli ultimi {days} giorni: il funnel si popola appena parte la prima campagna.
        </div>
      ) : (
        <>
          <FunnelBars stages={stages} compact />
          {data.hot_leads > 0 && (
            <Link to="/funnel?only=hot" data-testid="dashboard-hot-leads"
              style={{display:"inline-flex",alignItems:"center",gap:8,marginTop:14,
                      background:"#fff7ed",border:"1px solid #fed7aa",color:"#9a3412",
                      padding:"8px 12px",borderRadius:10,textDecoration:"none",fontWeight:600,fontSize:13}}>
              <Flame size={15}/> {data.hot_leads} lead caldi: hanno visto la catena ma non hanno prenotato
            </Link>
          )}
        </>
      )}
    </div>
  );
}
